module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-79b05e1b6872362768dd563167572fe4.png";